import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c985567"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexpool-skeleton" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__img" }),
  /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__content-holder" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__content" }),
    /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__content" }),
    /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__content" })
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__shifts" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__shifts-placeholder" }),
  /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__shifts-placeholder" })
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-wrap__skills" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CardWrap = _resolveComponent("CardWrap")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_CardWrap, { class: "card-wrap" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    })
  ]))
}